var loop = new Loop();

function SubNav() {

    var self = this;

    this.links = document.querySelectorAll('.header-sub-nav__link');
    this.items = [];
    this.active = null;
    this.subNav = document.querySelector('.header-sub-nav');
    this.sentinel = document.querySelector('.header-sub-nav-sentinel');
    this.nextElement = null;
    this.spacer = null;

    this.init = function() {
        if (this.links.length > 1) {
            this.getItems();
            this.check();
            document.addEventListener('scroll', this.check.bind(this));
        }

        // Initialize IntersectionObserver for sticky positioning
        this.initStickyObserver();
    };

    this.getItems = function() {
        loop.array(this.links, function(link, i) {
            if (link[i].hash.length > 0) {
                var el = document.querySelector(link[i].hash);
                if (el) {
                    self.items.push(el);
                }
            }
        });
    };

    this.check = function() {
        if (this.items.length === 0) {
            return;
        }

        var active = this.items[0].id;

        loop.array(this.items, function(item, i) {
            if (item[i].offsetTop <= document.documentElement.scrollTop + (window.innerHeight / 2)) {
                active = item[i].id;
            }
        });

        if (active != this.active) {
            this.active = active;

            this.updateNav();
        }
    };

    this.updateNav = function() {
        var activeLink = null;

        loop.array(this.links, function(link, i) {
            if (link[i].getAttribute('href').replace('#', '') == self.active) {
                activeLink = link[i];
            }
        });

        var oldLink = document.querySelector('.header-sub-nav__link--active');
        if (oldLink) {
            oldLink.classList.remove('header-sub-nav__link--active');
        }
        activeLink.classList.add('header-sub-nav__link--active');
    };

    this.setFixedState = function(isFixed) {
        if (!self.subNav) return;

        if (isFixed) {
            self.subNav.classList.add('is-fixed');
            // Create a spacer element to maintain layout space
            if (!self.spacer) {
                self.spacer = document.createElement('div');
                self.spacer.className = 'header-sub-nav-spacer';
                self.spacer.style.height = self.subNav.offsetHeight + 'px';
                self.spacer.style.visibility = 'hidden';
                self.subNav.parentNode.insertBefore(self.spacer, self.subNav);
            }
            self.spacer.style.display = 'block';
        } else {
            self.subNav.classList.remove('is-fixed');
            // Hide the spacer
            if (self.spacer) {
                self.spacer.style.display = 'none';
            }
        }
    };

    this.calculateRootMargin = function() {
        var baseHeaderHeight = 110; // Base header height in pixels
        var additionalHeight = 0;
        var body = document.body;

        // Check for debug class (adds 20px)
        if (body.classList.contains('body--debug')) {
            additionalHeight += 20;
        }

        // Check for admin class (adds 44px)
        if (body.classList.contains('body--admin')) {
            additionalHeight += 44;
        }

        // Check for notice bar class (adds 40px)
        if (body.classList.contains('has-notice-bar')) {
            additionalHeight += 40;
        }

        var totalHeight = baseHeaderHeight + additionalHeight;
        return '-' + totalHeight + 'px 0px 0px 0px';
    };

    this.initStickyObserver = function() {
        // Only proceed if we have both the sub-nav and sentinel elements
        if (!self.subNav || !self.sentinel) {
            return;
        }

        // Check if IntersectionObserver is supported
        if (!window.IntersectionObserver) {
            return;
        }

        // Find the next sibling element to apply negative margin compensation
        self.nextElement = self.subNav.nextElementSibling;

        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                // When the sentinel is NOT intersecting (i.e., it's above the viewport)
                // it means the main header has scrolled past it, so we should fix the sub-nav
                self.setFixedState(!entry.isIntersecting);
            });
        }, {
            // Use dynamic root margin based on actual header height
            rootMargin: self.calculateRootMargin(),
            threshold: 0
        });

        observer.observe(self.sentinel);
    };
}
